import React, { useEffect, useState } from 'react';
import { TeamOutlined, TrophyOutlined } from '@ant-design/icons';
import { Button, Card, Divider, Form, notification, Select, Slider } from 'antd';
import { _T } from '../../../../../base-react/src/Localization';
import { apis, models } from "@vote4dance/judging-sdk";
var Api = apis.Api;
var RoundItem = models.rounds.RoundItem;
import { RoundType } from '@vote4dance/judging-schema';
var ClassRoundSource = models.rounds.ClassRoundSource;
const { Option } = Select;
export const SendTeamsThrough = (props) => {
    const { round, classRounds, alternates, disabled, previewRound } = props;
    const [confirmLoading, setConfirmLoading] = useState(false);
    const [numApproved, setNumApproved] = useState(parseInt(round.round_num_approved));
    const [form] = Form.useForm();
    const getInitialFormValues = () => ({
        round_num_approved: parseInt(round.round_num_approved),
        round_num_alternates: round.round_num_alternates,
        round_target_id: round.round_target_id,
        round_others_id: round.round_others_id,
        round_update_best_placement: true,
        round_num_approved_preview: previewRound === null || previewRound === void 0 ? void 0 : previewRound.round_num_approved,
    });
    const throughRounds = classRounds && classRounds.filter(a => a.round_type == RoundType.Chance ||
        parseInt(a.round_parent_id) == 0 &&
            a.round_id != round.round_id);
    const skatingData = round.round_skating ? Array.from(round.round_skating).map((skate) => skate).sort((a, b) => a.count - b.count) : [];
    const skatingPreviewData = (previewRound === null || previewRound === void 0 ? void 0 : previewRound.round_skating) ? Array.from(previewRound.round_skating).map((skate) => skate).sort((a, b) => a.count - b.count) : [];
    const onFieldsChange = (values) => {
        values.forEach((change) => {
            if (change.name.includes('round_num_approved')) {
                setNumApproved(change.value);
                form.setFieldValue('round_num_alternates', 0);
            }
        });
    };
    const onFinish = (values) => {
        assignTeams(values);
        const othersId = values['round_others_id'];
        if (parseInt(othersId) > 0 && values.round_update_best_placement) {
            const updateRound = classRounds === null || classRounds === void 0 ? void 0 : classRounds.find(a => a.round_id == othersId);
            if (updateRound) {
                Api.update(`${ClassRoundSource(round.class_id).url}/${updateRound.round_id}`, {
                    ...updateRound,
                    round_position: values['round_num_approved'] + 1
                });
            }
        }
    };
    const assignTeams = async (values) => {
        setConfirmLoading(true);
        try {
            const updateRound = {
                ...round,
                ...values
            };
            await Api.update(`${ClassRoundSource(round.class_id).url}/${round.round_id}`, updateRound);
            if (round.round_status == 'closed') {
                await Api.call(`${ClassRoundSource(round.class_id).url}/${round.round_id}`, "assign-teams");
                if (alternates) {
                    await Api.call(`${ClassRoundSource(round.class_id).url}/${round.round_id}`, "prioritize-teams");
                }
            }
        }
        catch (err) {
            notification.error({
                message: err.message
            });
        }
        setConfirmLoading(false);
    };
    useEffect(() => {
        if (numApproved != undefined) {
            form.setFieldValue('round_num_approved', numApproved);
        }
    }, [form, numApproved]);
    useEffect(() => {
        const initialValues = getInitialFormValues();
        setNumApproved(initialValues.round_num_approved);
        form.resetFields();
        form.setFieldsValue(initialValues);
    }, [form, round.round_id]);
    useEffect(() => {
        form.setFieldValue('round_num_approved_preview', previewRound === null || previewRound === void 0 ? void 0 : previewRound.round_num_approved);
    }, [form, previewRound === null || previewRound === void 0 ? void 0 : previewRound.round_id, previewRound === null || previewRound === void 0 ? void 0 : previewRound.round_num_approved]);
    const approvedMarks = Object.fromEntries([
        ['0', { label: '0' }],
        ...skatingData.filter(state => !state.sideskated).map((state) => [
            state.count.toString(),
            {
                label: (React.createElement("span", { style: { fontStyle: state.sideskated > 0 ? 'italic' : 'inherit' } },
                    state.count,
                    state.sideskated > 0 && '*')),
            },
        ])
    ]);
    const previewMarks = Object.fromEntries([
        ['0', { label: '0' }],
        ...skatingPreviewData.map((state) => [
            state.count.toString(),
            {
                label: (React.createElement("span", { style: { fontStyle: state.sideskated > 0 ? 'italic' : 'inherit' } },
                    state.count,
                    state.sideskated > 0 && '*')),
            },
        ])
    ]);
    const alternatesMarks = Object.fromEntries([
        ['0', { label: '0' }],
        ...skatingData.filter(state => !state.sideskated && state.count > numApproved).map(state => [
            state.count.toString(),
            {
                label: (React.createElement("span", { style: { fontStyle: state.sideskated > 0 ? 'italic' : 'inherit' } },
                    (state.count - numApproved),
                    state.sideskated > 0 && '*')),
            },
        ])
    ]);
    const highestCount = skatingData.reduce((maxCount, state) => (state.count > maxCount ? state.count : maxCount), Number.MIN_SAFE_INTEGER);
    const highestPreviewCount = skatingPreviewData.reduce((maxCount, state) => (state.count > maxCount ? state.count : maxCount), Number.MIN_SAFE_INTEGER);
    const currentState = skatingData.find(state => state.count === numApproved);
    const formatter = (value) => value && value - numApproved;
    return (React.createElement(Card, { title: React.createElement(React.Fragment, null,
            React.createElement(TrophyOutlined, null),
            " ",
            _T('round.sendTeams.title')) },
        React.createElement(Form, { form: form, name: "basic", size: "large", labelCol: { span: 8 }, wrapperCol: { span: 10 }, labelWrap: true, disabled: disabled, initialValues: getInitialFormValues(), onFieldsChange: onFieldsChange, onFinish: onFinish },
            (previewRound === null || previewRound === void 0 ? void 0 : previewRound.round_skating) &&
                React.createElement(React.Fragment, null,
                    React.createElement(Form.Item, { label: _T('round.details.round_num_through.label'), extra: React.createElement("ul", null,
                            React.createElement("li", null,
                                _T('common.preview'),
                                " ",
                                RoundItem.getClassLabel(previewRound))), name: "round_num_approved_preview" },
                        React.createElement(Slider, { disabled: true, marks: previewMarks, max: highestPreviewCount, tooltip: { open: parseInt(previewRound === null || previewRound === void 0 ? void 0 : previewRound.round_num_approved) > 0 }, step: null })),
                    React.createElement(Divider, { dashed: true })),
            round.round_skating &&
                React.createElement(Form.Item, { label: _T('round.details.round_num_through.label'), extra: React.createElement("ul", null,
                        previewRound && React.createElement("li", null, RoundItem.getClassLabel(round)),
                        React.createElement("li", null,
                            _T('round.sendTeams.through.position'),
                            " ",
                            React.createElement("strong", null, currentState ? currentState.position : 0)),
                        React.createElement("li", null,
                            _T('round.sendTeams.through.average'),
                            " ",
                            React.createElement("strong", null, currentState ? currentState.average : 0)),
                        (currentState === null || currentState === void 0 ? void 0 : currentState.sideskated) ? React.createElement("li", null, _T('round.sendTeams.through.sideskated')) : null), name: "round_num_approved" },
                    React.createElement(Slider, { marks: approvedMarks, max: highestCount, tooltip: { open: true }, step: null })),
            alternates &&
                React.createElement(Form.Item, { label: _T('round.details.round_num_alternates.label'), name: "round_num_alternates" },
                    React.createElement(Slider, { marks: alternatesMarks, max: highestCount, tooltip: { formatter, open: true }, step: null })),
            React.createElement(Form.Item, { label: _T('round.sendTeams.through.title'), name: "round_target_id" },
                React.createElement(Select, { placeholder: _T('round.sendTeams.through.placeholder') },
                    React.createElement(Option, { value: "0", key: "0" }, _T('round.sendTeams.through.empty')),
                    throughRounds && throughRounds.map((classRound) => (React.createElement(Option, { value: classRound.round_id, disabled: classRound.round_status != 'open', key: classRound.round_id }, classRound.round_label))))),
            React.createElement(Form.Item, { label: _T('round.sendTeams.notThrough.title'), extra: _T('round.sendTeams.notThrough.extra'), name: "round_others_id" },
                React.createElement(Select, null,
                    React.createElement(Option, { value: "0", key: "0" }, _T('round.sendTeams.notThrough.empty')),
                    throughRounds && throughRounds.map((classRound) => (React.createElement(Option, { value: classRound.round_id, disabled: classRound.round_status != 'open', key: classRound.round_id }, classRound.round_label))))),
            React.createElement(Form.Item, { noStyle: true, shouldUpdate: (prevValues, currentValues) => prevValues.round_others_id !== currentValues.round_others_id }, ({ getFieldValue }) => {
                var _a, _b;
                return React.createElement(Form.Item, { label: _T('round.details.round_position.label'), extra: _T('round.details.round_position.help', { name: (_a = classRounds === null || classRounds === void 0 ? void 0 : classRounds.find(a => a.round_id == getFieldValue('round_others_id'))) === null || _a === void 0 ? void 0 : _a.round_label, value: getFieldValue('round_num_approved') + 1 }), name: "round_update_best_placement", hidden: parseInt(getFieldValue('round_others_id')) == 0 || ((_b = classRounds === null || classRounds === void 0 ? void 0 : classRounds.find(a => a.round_id == getFieldValue('round_others_id'))) === null || _b === void 0 ? void 0 : _b.round_type) === RoundType.Chance, dependencies: ['round_others_id'] },
                    React.createElement(Select, null,
                        React.createElement(Select.Option, { value: true, key: 'update' }, _T('round.details.round_position.update', { value: getFieldValue('round_num_approved') + 1 })),
                        React.createElement(Select.Option, { value: false, key: 'leave' }, _T('common.previous'))));
            }),
            React.createElement(Form.Item, { wrapperCol: { offset: 8, span: 16 } },
                React.createElement(Button, { loading: confirmLoading, icon: React.createElement(TeamOutlined, null), htmlType: "submit", type: "primary" }, alternates ? _T('round.details.priority.update') : _T('common.save'))))));
};
